export const flats = [
    {
        id      : '1',
        image   : ['https://eniteo.ru/assets/images/apartments/plans/section-1/1_25-36_7.svg?v=1732714108', 'https://eniteo.ru/assets/images/apartments/plans/section-1/1_25-36_7.svg?v=1732714108'],
        complex : 'Алые паруса 1',
        url     : 'alyeparusa.ru',
        number  : '№56',
        name    : '3к — 150.0 м²',
        propsTop: [
            '2 корпус',
            '1 секция',
            'Мастер спальни',
            'TopFloor',
        ],
        propsBottom: [
            'Отдельный вход',
            'Окно в гардеробной',
            'Пентхаус'
        ],
        price      : '23 230 000 ₽',
        priceOld   : '28 230 000 ₽',
        salePercent: '-25%'
    },
    {
        id      : '2',
        image   : 'https://eniteo.ru/assets/images/apartments/plans/section-1/1_25-36_7.svg?v=1732714108',
        complex : 'Алые паруса 2',
        url     : 'alyeparusa.ru',
        number  : '№56',
        name    : '3к — 150.0 м²',
        propsTop: [
            '2 корпус',
            '1 секция',
            'Мастер спальни',
            'TopFloor',
        ],
        propsBottom: [
            'Отдельный вход',
            'Окно в гардеробной',
            'Пентхаус'
        ],
        price: '23 230 000 ₽'
    },
    {
        id      : '3',
        image   : null,
        complex : 'Пыжевский',
        url     : 'pyzhevsky.ru',
        number  : '№56',
        name    : '3к — 150.0 м²',
        propsTop: [
            '2 корпус',
            '1 секция',
            'Мастер спальни',
            'TopFloor',
        ],
        propsBottom: [
            'Отдельный вход',
            'Окно в гардеробной',
            'Пентхаус'
        ],
        price: '23 230 000 ₽'
    },
    {
        id      : '4',
        image   : 'https://eniteo.ru/assets/images/apartments/plans/section-1/1_25-36_7.svg?v=1732714108',
        complex : 'Пыжевский',
        url     : 'pyzhevsky.ru',
        number  : '№56',
        name    : '3к — 150.0 м²',
        propsTop: [
            '2 корпус',
            '1 секция',
            'Мастер спальни',
            'TopFloor',
        ],
        propsBottom: [
            'Отдельный вход',
            'Окно в гардеробной',
            'Пентхаус'
        ],
        price: '23 230 000 ₽'
    },
    {
        id      : '5',
        image   : 'https://eniteo.ru/assets/images/apartments/plans/section-1/1_25-36_7.svg?v=1732714108',
        complex : 'Алые паруса',
        number  : '№56',
        name    : '3к — 150.0 м²',
        propsTop: [
            '2 корпус',
            '1 секция',
            'Мастер спальни',
            'TopFloor',
        ],
        propsBottom: [
            'Отдельный вход',
            'Окно в гардеробной',
            'Пентхаус'
        ],
        price: '23 230 000 ₽'
    },
    {
        id      : '6',
        image   : 'https://eniteo.ru/assets/images/apartments/plans/section-1/1_25-36_7.svg?v=1732714108',
        complex : 'Алые паруса',
        number  : '№56',
        name    : '3к — 150.0 м²',
        propsTop: [
            '2 корпус',
            '1 секция',
            'Мастер спальни',
            'TopFloor',
        ],
        propsBottom: [
            'Отдельный вход',
            'Окно в гардеробной',
            'Пентхаус'
        ],
        price: '23 230 000 ₽'
    },
    {
        id      : '7',
        image   : 'https://eniteo.ru/assets/images/apartments/plans/section-1/1_25-36_7.svg?v=1732714108',
        complex : 'Алые паруса',
        number  : '№56',
        name    : '3к — 150.0 м²',
        propsTop: [
            '2 корпус',
            '1 секция',
            'Мастер спальни',
            'TopFloor',
        ],
        propsBottom: [
            'Отдельный вход',
            'Окно в гардеробной',
            'Пентхаус'
        ],
        price: '23 230 000 ₽'
    },
    {
        id      : '8',
        image   : 'https://eniteo.ru/assets/images/apartments/plans/section-1/1_25-36_7.svg?v=1732714108',
        complex : 'Алые паруса',
        number  : '№56',
        name    : '3к — 150.0 м²',
        propsTop: [
            '2 корпус',
            '1 секция',
            'Мастер спальни',
            'TopFloor',
        ],
        propsBottom: [
            'Отдельный вход',
            'Окно в гардеробной',
            'Пентхаус'
        ],
        price: '23 230 000 ₽'
    },
    {
        id      : '9',
        image   : 'https://eniteo.ru/assets/images/apartments/plans/section-1/1_25-36_7.svg?v=1732714108',
        complex : 'Алые паруса',
        number  : '№56',
        name    : '3к — 150.0 м²',
        propsTop: [
            '2 корпус',
            '1 секция',
            'Мастер спальни',
            'TopFloor',
        ],
        propsBottom: [
            'Отдельный вход',
            'Окно в гардеробной',
            'Пентхаус'
        ],
        price: '23 230 000 ₽'
    },
    {
        id      : '10',
        image   : 'https://eniteo.ru/assets/images/apartments/plans/section-1/1_25-36_7.svg?v=1732714108',
        complex : 'Алые паруса',
        number  : '№56',
        name    : '3к — 150.0 м²',
        propsTop: [
            '2 корпус',
            '1 секция',
            'Мастер спальни',
            'TopFloor',
        ],
        propsBottom: [
            'Отдельный вход',
            'Окно в гардеробной',
            'Пентхаус'
        ],
        price: '23 230 000 ₽'
    },
    {
        id      : '11',
        image   : 'https://eniteo.ru/assets/images/apartments/plans/section-1/1_25-36_7.svg?v=1732714108',
        complex : 'Алые паруса',
        number  : '№56',
        name    : '3к — 150.0 м²',
        propsTop: [
            '2 корпус',
            '1 секция',
            'Мастер спальни',
            'TopFloor',
        ],
        propsBottom: [
            'Отдельный вход',
            'Окно в гардеробной',
            'Пентхаус'
        ],
        price: '23 230 000 ₽'
    },
    {
        id      : '12',
        image   : 'https://eniteo.ru/assets/images/apartments/plans/section-1/1_25-36_7.svg?v=1732714108',
        complex : 'Алые паруса',
        number  : '№56',
        name    : '3к — 150.0 м²',
        propsTop: [
            '2 корпус',
            '1 секция',
            'Мастер спальни',
            'TopFloor',
        ],
        propsBottom: [
            'Отдельный вход',
            'Окно в гардеробной',
            'Пентхаус'
        ],
        price: '23 230 000 ₽'
    }
];
